.group {
	display: flex;
	flex-direction: column;
	gap: var(--lp-spacing-500);
	margin: 0;
	padding: 0;
	border: none;
}

.legend {
	font: var(--lp-text-label-1-medium);
	padding: 0;
	display: contents;
}
